import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {finalize} from "rxjs/operators";

import {LinkInfo} from '../../defines/client.const';
import {MP_RESULT, MpConfig} from '../../components/common-popups/msg-popup.component';
import {StatusCommonPopups} from "../../components/common-popups/common-popups.component";


@Injectable({
  providedIn: 'root'
})
export class LayoutMgrService implements StatusCommonPopups {

  /**************************************************************************
   * implement StatusCommonPopups
   **************************************************************************/
  public get showMsg(): boolean {
    return this.msgPopup$ !== null;
  }

  public get showYoutube(): boolean {
    return this.youtubePopup$ !== null;
  }

  public get showNaverLogin(): boolean {
    return this.naverLoginPopup$ !== null;
  }
  /**************************************************************************/

  // msg-popup 관련
  public mpConfig: MpConfig | null = null;
  // public mpConfig: MpConfig = {
  //   msg: '테스트 팝업 본문',
  //   title: '테스트 제목',
  //   image: 'assets/img/ic_popup_error.svg',
  //   btnOk: '확인',
  // };
  public msgPopup$: Subject<MP_RESULT> | null = null;


  public naverLoginPopup$: Subject<string|null> | null = null;


  constructor() { }

  // public get isOverlay(): boolean {
  //   return this.showMenu || this.showBookmark || this.showHelp || this.showMsg || this.showPitch;
  // }

  // public get isOverlay2(): boolean {
  //   return this.showPitch && (this.showHelp || this.showMsg);
  // }

  // public get PaddingClass(): string {
  //   return this.showIndex ? 'page-keyword' : 'page-keyword2';
  // }


  // msg-popup 관련
  public OpenMsgPopup(config: MpConfig): Observable<MP_RESULT> {
    this.mpConfig = config;
    this.msgPopup$ = new Subject<MP_RESULT>();
    return this.msgPopup$.pipe(
      finalize(() => {
        this.mpConfig = null;
        this.msgPopup$ = null;
      }),
    );
  }

  public OpenMsgPopupAlert(msg: string, title: string = '오류'): Observable<MP_RESULT> {
    return this.OpenMsgPopup({
      title,
      msg,
      btnError: '확인',
    });
  }

  public OpenNaverLoginPopup(): Observable<string|null> {
    this.naverLoginPopup$ = new Subject<string|null>();
    return this.naverLoginPopup$.pipe(
      finalize(() => {
        this.naverLoginPopup$ = null;
      }),
    );
  }

  public onClickMsgBtn(mpResult: MP_RESULT): void {
    // console.log('lm::onClickMsgBtn()');
    if (this.msgPopup$ === null) {
      throw new Error('LayoutMgrService::onClickMsgBtn() - msgPopup$ is null')
    }
    this.msgPopup$.next(mpResult);
    this.msgPopup$.complete();
  }


  public youtubeId: string | null = null;
  public youtubePopup$: Subject<string | null> | null = null;
  public OpenYoutubePopup(youtubeId: string): Observable<string | null> {
    this.youtubeId = youtubeId;
    this.youtubePopup$ = new Subject<string | null>();
    return this.youtubePopup$.pipe(
      finalize(() => {
        this.youtubeId = null;
        this.youtubePopup$ = null;
      })
    );
  }
  public CloseYoutubePopup(): void {
    if (this.youtubePopup$) {
      this.youtubePopup$.next(null);
      this.youtubePopup$.complete();
    }
  }

}
